module.exports = __webpack_public_path__ + "static/media/RI-D2-3.2-072.b860c091.webp";